var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLandscape = function SvgLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226,
    height: 95,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "landscape_svg__a",
    width: 226,
    height: 95,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.816.944h224.508v94H.816z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#landscape_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.618,
    cy: 26.988,
    r: 21.694,
    fill: "#F6BC2D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M85.63 108.273c-3.572-.004-5.349-4.33-2.81-6.843l72.367-71.628a4 4 0 0 1 5.656.03L231.88 101.6c2.501 2.528.709 6.818-2.847 6.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M21.224 108.408c-3.572 0-5.353-4.325-2.816-6.84l55.537-55.067a4 4 0 0 1 5.656.024l54.612 55.079c2.504 2.525.715 6.816-2.84 6.816z"
  }))));
};
export { SvgLandscape as ReactComponent };
export default __webpack_public_path__ + "images/landscape.svg";